module.exports = __webpack_public_path__ + "static/nexus-mentis-results-8c7f250640b5c7523e4ae6e7f8237269.png";